import {Total} from './total';

export class Price {
  total: Total;

  constructor(price: number) {
    this.total = new Total(price);
  }

  public getTotal(): Total {
    return this.total;
  }
}
